// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__IzeDr","signIn":"style_signIn__7LUTX","button":"style_button__4H8Xf","title":"style_title__lFZ5F","input":"style_input__afFlA"};